import { PaginatedAuditContainer } from "./paginated-audit-container"
import { DefaultAuditContainer } from "./default-audit-container"

/**
 * Routes an activity log to either incremental loading (when `pageSize` is set and the log is the
 * reference-id/type kind) or the standard fetch-everything container. Kept hook-free so the choice
 * can be made before any hooks run.
 */
export function AuditContainer(props) {
    const { pageSize, forTypeAllClients, published } = props

    // Opt-in incremental loading for activity logs that can be enormous (e.g. a regime promoted
    // from a scenario). The all-clients and approved-changes paths are not paginated.
    if (pageSize && !forTypeAllClients && !published) {
        const { setOpen, type, id, fileNamePrefix, filterFn, isDialog, filter } = props
        return (
            <PaginatedAuditContainer
                setOpen={setOpen}
                type={type}
                id={id}
                fileNamePrefix={fileNamePrefix}
                filterFn={filterFn}
                isDialog={isDialog}
                filter={filter}
                pageSize={pageSize}
            />
        )
    }

    return <DefaultAuditContainer {...props} />
}
